import { render, staticRenderFns } from "./CategoryCreateEdit.vue?vue&type=template&id=31f1a64a&scoped=true&"
import script from "./CategoryCreateEdit.vue?vue&type=script&lang=js&"
export * from "./CategoryCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f1a64a",
  null
  
)

export default component.exports